import { createFileRoute } from "@tanstack/react-router";
import { GeneralSettings } from "@/features/settings/general";

export const Route = createFileRoute("/_app/settings/general")({
  head: () => ({ meta: [{ title: "General · Settings · Malfak" }] }),
  component: GeneralSettings,
});
